var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.parcelle.NonCadastree
        ? [
            _vm._v("\n        [Non cadastré] "),
            _c("strong", [
              _vm._v(
                _vm._s(_vm.parcelle.DNUVOI) +
                  " " +
                  _vm._s(_vm.parcelle.DINDIC) +
                  " " +
                  _vm._s(_vm.parcelle.NATVOI) +
                  " " +
                  _vm._s(_vm.parcelle.LIBVOI)
              )
            ])
          ]
        : [
            _vm.parcelle.Introuvable
              ? [_vm._v("\n            [Introuvable]\n        ")]
              : _vm._e(),
            _vm._v(" "),
            _c("strong", [
              _vm._v(
                _vm._s(_vm.parcelle.CCOSEC) + " " + _vm._s(_vm.parcelle.DNUPLA)
              )
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("em", [
              _vm._v(
                _vm._s(_vm.parcelle.DNUVOI) +
                  " " +
                  _vm._s(_vm.parcelle.DINDIC) +
                  " " +
                  _vm._s(_vm.parcelle.NATVOI) +
                  " " +
                  _vm._s(_vm.parcelle.LIBVOI)
              )
            ])
          ],
      _vm._v(" "),
      _vm.parcelle.DCNTPA
        ? [
            _vm._v(
              "\n        — " +
                _vm._s(_vm.parcelle.DCNTPA.toLocaleString()) +
                " m²\n    "
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.parcelle.DomainePublic
        ? _c("div", [_vm._v("\n        Domaine public\n    ")])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fe2d45f0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fe2d45f0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./_wwwsrc/js/ConventionServitude/Components/ResumeParcelle.vue
// module id = 666
// module chunks = 0